import { render, staticRenderFns } from "./SafetyAppearanceSettings.vue?vue&type=template&id=359720ea&scoped=true"
import script from "./SafetyAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SafetyAppearanceSettings.vue?vue&type=style&index=0&id=359720ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359720ea",
  null
  
)

export default component.exports